import AddCourse from "../../Components/Modals/AddCourse";
import Table from "../../Components/Table";
import { deleteCourseById, getAllCourse } from "../../Services/MasterService";

const Course = () => {
    const columns = [
        {
            label: "Name",
            value: "name"
        },
        {
            label: "Parent",
            value: "parent_name"
        },

        {
            label: "Background Image",
            value: "background_image",
                        renderValue: (value) => {
                return (
                    <img width={70} src={value} alt="..." class="img-thumbnail"/>
                )
            }
        },
        {
            label: "Image",
            value: "image",
                        renderValue: (value) => {
                return (
                    <img width={70} src={value} alt="..." class="img-thumbnail"/>
                )
            }
        },
        {
            label: "Slug",
            value: "slug"
        },
        {
            label: "Duration(Months)",
            value: "duration",
        },
        {
            label: "Description",
            value: "description",
        },
        {
            label: "Status",
            value: "status_name",
        },
    ];

    const renderAddModal = (openAddModal, setOpenAddModal) => {
        return (
            <AddCourse data={openAddModal} onClose={() => setOpenAddModal()} onCloseWithApi={() => setOpenAddModal(true)} />
        )
    };

    return (
        <Table
            api={getAllCourse}
            columns={columns}
            title={"Course Master"}
            addModal={renderAddModal}
            showAddButton={true}
            showExportButton={true}
            deleteApi={deleteCourseById}
        />
    );
}

export default Course;